import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'user-profile',
		path: '/u/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/profile" */ './index'), {
			exportName: 'UserProfile',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			nonGuestOnly: true,
		},
		ssr: {
			enabled: true,
			seo: false, // non point, since it's non-guest only
		},
	},
];
